module.exports = __webpack_public_path__ + "img/microneedling-circle.a47e33a3.svg";